// extracted by mini-css-extract-plugin
export default {"prompt":"Prompt_prompt__2EHYg"};